import { render, staticRenderFns } from "./MovementsPage.vue?vue&type=template&id=67a384ae&scoped=true"
import script from "./MovementsPage.vue?vue&type=script&lang=js"
export * from "./MovementsPage.vue?vue&type=script&lang=js"
import style0 from "./MovementsPage.vue?vue&type=style&index=0&id=67a384ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a384ae",
  null
  
)

export default component.exports